{
  window.addEventListener('DOMContentLoaded', function() {


    const filterItems = document.querySelectorAll('.sbn-c-checkbox-condition__source');
    filterItems.forEach(function(item) {
      item.addEventListener('click', function() {
        updateURL();
      });
    });


    function updateURL(){
      const filters = [];
      const removeFilters = [];
      const filterItems = document.querySelectorAll('.sbn-c-checkbox-condition__source');
      filterItems.forEach(function(item) {
        const filterValue = item.value;
        const filterName = item.name;
        // checkedの場合
        if (item.checked) {
          filters.push({
            name: filterName,
            value: filterValue
          });
        }
      });
      const url = new URL(window.location.href);
      // クエリパラメータを削除
      url.searchParams.forEach(function(value, key) {
        if(key !== 'view'){
          removeFilters.push(key);
        }
      });
      removeFilters.forEach(function(filter) {
        url.searchParams.delete(filter);
      });
      filters.forEach(function(filter) {
        url.searchParams.append(filter.name, filter.value);
      });
      window.history.pushState({}, '', url.href);
      renderPage(url);
    }

    function initPage(){
      // URLにfilterが入っていたら、全て行をgrayscale(0)にする
      const urlParams = new URLSearchParams(window.location.search);
      console.log(urlParams.toString());
      const rows = document.querySelectorAll('.sbn-c-cellcontent-model');
      if (urlParams.toString() && urlParams.toString().includes('filter')) {
        console.log('initPage');
        rows.forEach(row => {
          row.querySelectorAll('.sbn-c-cellcontent-model__thumbnail, .sbn-c-cellcontent-model__image').forEach(thumbnail => {
            console.log(thumbnail);
            thumbnail.style.filter = 'grayscale(0%)';
          });
        });
      }

      rows.forEach(row => {
        // rowsにマウスがのったら sbn-c-table-primary__bodyからno-hoverを削除
        row.addEventListener('mouseenter', function() {
          row.classList.remove('no-hover');
        });
        row.addEventListener('mouseleave', function() {
          row.classList.add('no-hover');
        });
      })

  }

    async function renderPage(url){
      await fetch(url.href)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productGrid = doc.getElementById('collection-comparison');
          const productGridContainer = document.getElementById('collection-comparison');
          productGridContainer.innerHTML = productGrid.innerHTML;
        }).finally(() => {
          initPage();
          console.log('renderPage done');
        });
    }

    initPage();

  });
}
